// extracted by mini-css-extract-plugin
module.exports = {"section":"_1KPbh","competitionTable":"_17Pjy"};